import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface MeaningfulFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for filtering sessions by meaningful status
 */
export const MeaningfulFilter = ({ filterIndex }: MeaningfulFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const isMeaningful = useWatch({ control, name: `filters.${filterIndex}.isMeaningful` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null; // 'all' option
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, isMeaningful: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup
        value={isMeaningful?.toString() || ''}
        onValueChange={handleChange}
        className="gap-0"
      >
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background">
          <RadioGroupItem value="true" id={`meaningful-true-${filterIndex}`} />
          <Label htmlFor={`meaningful-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.onlyMeaningfulConversations')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background">
          <RadioGroupItem value="false" id={`meaningful-false-${filterIndex}`} />
          <Label htmlFor={`meaningful-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.hideMeaningfulConversations')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
